<div class="d-flex flex-column">
    <div class="d-flex align-items-center justify-content-between p-3">
        <h4>User Logout</h4>
        <button mat-icon-button aria-label="close dialog" disableRipple mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <p class="asda-fs-16 fw-400 mb-5">{{ data.message }}</p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-flat-button class="text-white" [mat-dialog-close]="'ok'" color="primary"
            cdkFocusInitial>
            OK
        </button>
        <button mat-flat-button class="text-white" [mat-dialog-close]="'logout'" color="primary">
            Logout
        </button>
    </mat-dialog-actions>
</div>